import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Footer } from '@components/Layout'
import { ApplicationForm } from '@components/ui/ContactFormSection/ApplicationForm'
import { Seo } from '@components/Seo'
import { useLang, withLang } from '@shared/i18n/useLang'

export function ZayavkaPage() {
  const { t } = useTranslation()
  const lang = useLang()
  const how = t('zayavka.how', { returnObjects: true }) as string[]

  return (
    <>
      <Seo title={t('seo.zayavka.title')} description={t('seo.zayavka.description')} />

      {/* Page head */}
      <section className="section-hero-bg" style={{ padding: '64px 0' }}>
        <div className="container-page" style={{ display: 'flex', flexDirection: 'column', gap: 16, alignItems: 'flex-start' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, letterSpacing: '.08em', textTransform: 'uppercase' }}>
            <Link to={withLang(lang, '/')} style={{ color: '#5C6670', transition: 'color .15s' }}>{t('common.home')}</Link>
            <span style={{ color: '#3A434D' }}>/</span>
            <span style={{ color: '#93A3AE' }}>{t('zayavka.pageTitle')}</span>
          </div>
          <h1 className="h1-page" style={{ margin: 0, fontSize: 44, fontWeight: 750, letterSpacing: '-.015em', color: '#FFFFFF' }}>{t('zayavka.pageTitle')}</h1>
          <p style={{ margin: 0, fontSize: 16, lineHeight: 1.65, color: '#93A3AE', maxWidth: 640 }}>
            {t('zayavka.pageSubtitle')}
          </p>
        </div>
      </section>

      {/* Форма + сайдбар */}
      <section style={{ padding: '56px 0 88px' }}>
        <div className="container-page grid-form">

          <ApplicationForm />

          {/* Sidebar */}
          <aside style={{ display: 'flex', flexDirection: 'column', gap: 16, position: 'sticky', top: 104 }}>
            <div style={{ background: '#171C22', borderRadius: 3, padding: 28, display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ width: 8, height: 8, background: '#189BD5' }} />
                <span style={{ fontSize: 11, fontWeight: 600, letterSpacing: '.14em', textTransform: 'uppercase', color: '#93A3AE' }}>{t('zayavka.howTitle')}</span>
              </div>
              {how.map((text, i) => (
                <div key={i} style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                  <span style={{ color: '#29ABE2', fontSize: 13, fontWeight: 700, flexShrink: 0, width: 22 }}>{String(i + 1).padStart(2, '0')}</span>
                  <span style={{ fontSize: 13.5, lineHeight: 1.55, color: '#C4CDD4' }}>{text}</span>
                </div>
              ))}
            </div>

            <div className="card" style={{ padding: 28, display: 'flex', flexDirection: 'column', gap: 12 }}>
              <span style={{ fontSize: 11, fontWeight: 600, letterSpacing: '.14em', textTransform: 'uppercase', color: '#5C6670' }}>{t('zayavka.callFaster')}</span>
              <a href="tel:+70000000000" style={{ fontSize: 19, fontWeight: 700, color: '#171C22', transition: 'color .15s' }}>+7 (XXX) XXX-XX-XX</a>
              <span style={{ fontSize: 12.5, color: '#93A3AE' }}>{t('zayavka.callHours')}</span>
            </div>
          </aside>
        </div>
      </section>

      <Footer />
    </>
  )
}
